import React from "react";
import { Container } from "./styled/menu-divider";

function MenuDivider() {
  return React.createElement(Container, {
    "aria-hidden": "true"
  });
}

export default MenuDivider;